import {
  queryRoomLotterys,
  createLotteryRoom,
  queryLotteryRoomByAreaAndNo,
  queryLotteryRoomByArea,
  queryLotteryRoomNotice,
  queryLotteryRoomBankerInfo,
  joinOrQuitBankerQueue,
  queryExistInBankerQueue,
  queryRoomBankerQueue,
  queryRoomOpenTime,
  becomeRoomBanker,
  queryBankerProfitRecord,
  queryLotteryRoomStatus,
  queryRoomAreas,
  giveUpBecomeBanker
} from "@/api/conduct";

import {
  SET_GRAB_PERIOD,
  SET_GRAB_ROOM_ID,
  ADD_GRAB_ROOM_MESSAGE,
  ADD_GRAB_AITE_PEOPLE,
  CLEAR_GRAB_AITE_PEOPLE,
  DELETE_GRAB_AITE_PEOPLE,
  SET_GRAB_AITE_MESSAGE,
  SET_GRAB_ROOM_INFO,
  CLEAR_GRAP_ROOM_INFO_USER,
  SET_GRAB_ROOM_MESSAGE,
  SET_GRAB_LOTTERY_DOWNTIME,
  SET_GRAB_MSG_BAR_OPEN,
  SET_GRAB_JOIN_ROOM_STATE,
  SET_GRAB_PEOPLE_INFO,
  DELETE_GRAB_MESSAGE_LIST,
  SET_GRAB_IS_DISTER_VILLAGE,
  SET_GRAB_RECEIVE_ROOM_MSG,
  UPDADE_GRAB_ROOM_MESSAGE,
  SET_GRAP_SELF_JOIN_TIME,
  SET_GRAB_URL_INFO,
  SET_GRAP_OLD_BRANKER,
  SET_GRAB_ROOM_SPEECH_MODE
} from "@/store/mutation_types";

const grabVillage = {
  state: {
    grabRoomInfo: {},
    grabPeriod: {},
    grabRongyunId: null,
    grabRoomMsg: [],
    grabReceiveRoomMsg: {},
    // grabAiteList: []
    grabAiteMsg: {},
    grabLotteryDownTime: "00:00:00",
    grapMsgBarOpen: false, // 底部是否展开
    grapJoinRoomState: 0, //加入聊天室是否成功
    grapSelfJoinTime: 0, //自己抢庄成功
    grapUrlInfo: {},
    grapOldBranker: {},
    grapIsDistrVillage: false, // 是否分配了庄家
    grabRoomSpeechMode: "" // 接收融云的抢庄房的发言模式 0 自由发言，1，快捷发言，2禁言
  },
  getters: {
    grabRoomInfo: state => state.grabRoomInfo,
    grabPeriod: state => state.grabPeriod,
    grabRongyunId: state => state.grabRoomInfo.rongyunChatRoomId,
    grabRoomMsg: state => state.grabRoomMsg,
    grabReceiveRoomMsg: state => state.grabReceiveRoomMsg,
    // grabAiteList: state => state.grabAiteList
    grabAiteMsg: state => state.grabAiteMsg,
    grabLotteryDownTime: state => state.grabLotteryDownTime,
    grapMsgBarOpen: state => state.grapMsgBarOpen,
    grapJoinRoomState: state => state.grapJoinRoomState,
    grapIsDistrVillage: state => state.grapIsDistrVillage,
    grapSelfJoinTime: state => state.grapSelfJoinTime,
    grapUrlInfo: state => state.grapUrlInfo,
    grapOldBranker: state => state.grapOldBranker,
    grabRoomSpeechMode: state => state.grabRoomSpeechMode
  },
  mutations: {
    [SET_GRAB_ROOM_SPEECH_MODE]: (state, payload) => {
      state.grabRoomSpeechMode = payload;
    },
    [SET_GRAB_ROOM_INFO]: (state, payload) => {
      state.grabRoomInfo = payload;
    },
    [CLEAR_GRAP_ROOM_INFO_USER]: (state, payload) => {
      const grabRoomInfo = state.grabRoomInfo;
      grabRoomInfo.userName = "";
      grabRoomInfo.userId = "";
      grabRoomInfo.userIcon = "";
      grabRoomInfo.money = "";
      state.grabRoomInfo = grabRoomInfo;
    },
    [SET_GRAB_PERIOD]: (state, payload) => {
      state.grabPeriod = payload;
    },
    [SET_GRAB_MSG_BAR_OPEN]: (state, payload) => {
      state.grapMsgBarOpen = payload;
    },
    [SET_GRAB_RECEIVE_ROOM_MSG]: (state, payload) => {
      state.grabReceiveRoomMsg = payload;
    },
    [SET_GRAB_JOIN_ROOM_STATE]: (state, payload) => {
      state.grapJoinRoomState = payload;
    },
    [SET_GRAB_IS_DISTER_VILLAGE]: (state, payload) => {
      state.grapIsDistrVillage = payload;
    },
    [SET_GRAP_OLD_BRANKER]: (state, payload) => {
      state.grapOldBranker = payload;
    },

    [SET_GRAB_URL_INFO]: (state, payload) => {
      state.grapUrlInfo = payload;
    },
    [SET_GRAP_SELF_JOIN_TIME]: (state, payload) => {
      state.grapSelfJoinTime = payload;
    },
    [DELETE_GRAB_MESSAGE_LIST]: (state, payload) => {
      const { position, success } = payload;
      if (position === "head") {
        return state.grabRoomMsg.shift();
      }
      if (position === "tail") {
        return state.grabRoomMsg.pop();
      }
      if (typeof position === "number") {
        return state.grabRoomMsg.splice(position, 1);
      }
      throw new Error("ADD_GRAB_MESSAGE_LIST：错误的删除位置");
    },
    /*   [SET_GRAB_ROOM_ID]: (state, payload) => {
      state.grabRongyunId = payload;
    }, */
    [SET_GRAB_ROOM_MESSAGE]: (state, payload) => {
      state.grabRoomMsg = payload;
    },
    [ADD_GRAB_ROOM_MESSAGE]: (state, payload) => {
      state.grabRoomMsg.push(payload);
    },
    [UPDADE_GRAB_ROOM_MESSAGE]: (state, payload) => {
      const { position, message } = payload;
      state.grabRoomMsg.splice(position, 1, message);
    },
    [SET_GRAB_AITE_MESSAGE]: (state, payload) => {
      state.grabAiteMsg = payload;
    },
    [SET_GRAB_LOTTERY_DOWNTIME]: (state, payload) => {
      state.grabLotteryDownTime = payload;
    }
    // [ADD_GRAB_AITE_PEOPLE]: (state, payload) => {
    //   for (let i = 0, len = state.grabAiteList.length; i < len; i++) {
    //     if (state.grabAiteList[i].id === payload.user.id) {
    //       return;
    //     }
    //   }
    //   state.grabAiteList.push(payload);
    // },
    // [CLEAR_GRAB_AITE_PEOPLE]: (state, payload) => {
    //   state.grabAiteList = [];
    // },
    // [DELETE_GRAB_AITE_PEOPLE]: (state, payload) => {}
  },
  actions: {
    async queryRoomLotterys({ commit }, playload) {
      return await queryRoomLotterys(playload.data, playload.config);
    },
    async createLotteryRoom({ commit }, playload) {
      return await createLotteryRoom(playload.data, playload.config);
    },
    async queryLotteryRoomByAreaAndNo({ commit }, playload) {
      return await queryLotteryRoomByAreaAndNo(playload.data, playload.config);
    },
    async queryLotteryRoomByArea({ commit }, playload) {
      return await queryLotteryRoomByArea(playload.data, playload.config);
    },
    async queryLotteryRoomNotice({ commit }, playload) {
      return await queryLotteryRoomNotice(playload.data, playload.config);
    },
    async queryLotteryRoomBankerInfo({ commit }, playload) {
      return await queryLotteryRoomBankerInfo(playload.data, playload.config);
    },
    async joinOrQuitBankerQueue({ commit }, playload) {
      return await joinOrQuitBankerQueue(playload.data, playload.config);
    },
    async queryExistInBankerQueue({ commit }, playload) {
      return await queryExistInBankerQueue(playload.data, playload.config);
    },
    async queryRoomBankerQueue({ commit }, playload) {
      return await queryRoomBankerQueue(playload.data, playload.config);
    },
    async queryRoomOpenTime({ commit }, playload) {
      return await queryRoomOpenTime(playload.data, playload.config);
    },
    async becomeRoomBanker({ commit }, playload) {
      return await becomeRoomBanker(playload.data, playload.config);
    },
    async queryBankerProfitRecord({ commit }, playload) {
      return await queryBankerProfitRecord(playload.data, playload.config);
    },
    async queryLotteryRoomStatus({ commit }, playload) {
      return await queryLotteryRoomStatus(playload.data, playload.config);
    },
    async queryRoomAreas({ commit }, playload) {
      return await queryRoomAreas(playload.data, playload.config);
    },
    async giveUpBecomeBanker({ commit }, playload) {
      return await giveUpBecomeBanker(playload.data, playload.config);
    }
  }
};

export default grabVillage;
